/// <amd-module name="Test/Analytics/Common/Constants" />
export const TestOutcomeStringMap = {
    Unspecified: "Unspecified",
    None: "None",
    Passed: "Passed",
    Failed: "Failed",
    Inconclusive: "Inconclusive",
    Timeout: "Timeout",
    Aborted: "Aborted",
    Blocked: "Blocked",
    NotExecuted: "NotExecuted",
    Warning: "Warning",
    Error: "Error",
    NotApplicable: "NotApplicable",
    Paused: "Paused",
    InProgress: "InProgress",
    NotImpacted: "NotImpacted"
};

export const axServiceInstanceId = "0000003c-0000-8888-8000-000000000000";
export const emsServiceInstanceId = "00000028-0000-8888-8000-000000000000";
